export default __webpack_public_path__ + "static/media/thunderingvoice.594a38c8.png";